





















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Job } from '@/models/job.interface';
import { Action, Getter } from 'vuex-class';
import { ModalOptions } from '@/models/modal.interface';

@Component
export default class JobCardInfo extends Vue {
  @Prop() private job!: Job;
}
